module.exports = __webpack_public_path__ + "static/bucataras-53ad238152ac9dd9772f0e126724ec4f.png";